import { Component, OnInit } from '@angular/core';
import { OnboardingService } from '../../onboarding.service';
import { ActivatedRoute, Router } from '@angular/router';

interface ToggleProperties {

  name: string;
  ischecked: boolean;
  isDisabled: boolean;
}

@Component({
  selector: 'app-setup2',
  templateUrl: './setup2.component.html',
  styleUrls: ['./setup2.component.css']
})
export class Setup2Component implements OnInit {

  userId: any;
  submitButtonEnabled: boolean = false;

  selectedFanBoxes: any = 0;
  selectedCreatorBoxes: any = 0;
  // checkbox: any[];

  toggleDataFan: ToggleProperties[] = [
    {
      name: 'Art & Design',
      ischecked: false,
      isDisabled: false
    },
    {
      name: 'Books & Storytelling',
      ischecked: false,
      isDisabled: false
    },
    {
      name: 'Dance',
      ischecked: false,
      isDisabled: false
    },
    {
      name: 'Fashion',
      ischecked: false,
      isDisabled: false,
    },
    {
      name: 'Film',
      ischecked: false,
      isDisabled: false,
    },
    {
      name: 'Music',
      ischecked: false,
      isDisabled: false,
    },
    {
      name: 'Tech & Science',
      ischecked: false,
      isDisabled: false,
    },
    {
      name: 'Television',
      ischecked: false,
      isDisabled: false,
    },
    {
      name: 'Virtual Reality',
      ischecked: false,
      isDisabled: false,
    },
  ];

  toggleDataCreator: ToggleProperties[] = [
    {
      name: 'Art & Design',

      ischecked: false,
      isDisabled: false,
    },
    {
      name: 'Books & Storytelling',

      ischecked: false,
      isDisabled: false,
    },
    {
      name: 'Dance',
      ischecked: false,
      isDisabled: false,
    },
    {
      name: 'Fashion',
      ischecked: false,
      isDisabled: false,
    },
    {
      name: 'Film',
      ischecked: false,
      isDisabled: false,
    },
    {
      name: 'Music',
      ischecked: false,
      isDisabled: false,
    },
    {
      name: 'Tech & Science',

      ischecked: false,
      isDisabled: false,
    },
    {
      name: 'Television',

      ischecked: false,
      isDisabled: false,
    },
    {
      name: 'Virtual Reality',

      ischecked: false,
      isDisabled: false,
    },
  ];

  totalCount: number = 0;
  fanCount: number = 0;
  creatorCount: number = 0;
  userProfile: any;
  fanOfUser: any;
  createrOfUser: any;

  constructor(
    private onboardingService: OnboardingService, private route: ActivatedRoute,
    private Router: Router ){this.userId = route.snapshot.params.id; }
   
  

  ngOnInit(): void {
    this.onboardingService.getUserProfile(this.userId).subscribe((res) => {
      this.userProfile = res;

     this.fanOfUser= this.userProfile.fanOf;
     this.createrOfUser= this.userProfile.creatorOf;

     console.log(res);

      this.fanOfUser.map((v)=>{
        let val = this.toggleDataFan.find((p)=> v.name === p.name);
        val.ischecked = true;
        this.fanCount =1;
        
      })
      this.createrOfUser.map((v)=>{
        let val1 = this.toggleDataCreator.find((p)=> v.name === p.name);
        val1.ischecked = true;
this.creatorCount=1;
      })
      if(this.fanCount && this.creatorCount >= 1) {
        this.submitButtonEnabled = true;
      }
     else{ this.submitButtonEnabled = false;}
this.onToggleChange();
this.onToggleChange1();
    })
    this.onboardingService.getShowcases().subscribe((res: any) => {
      this.userId = res.user;
      console.log(this.userId);
    });
  }

  onToggleChange() {
    var count = 0;
    for (var i = 0; i < this.toggleDataFan.length; i++) {
      if (this.toggleDataFan[i].ischecked) {
        count++;
      }
    }

    if (count == 3) {
      this.fanCount = 3;
      this.totalCount = this.fanCount + this.creatorCount;
      for (var i = 0; i < this.toggleDataFan.length; i++) {
        if (this.toggleDataFan[i].ischecked == false) {
          this.toggleDataFan[i].isDisabled = true;
        }
      }
    }
  
    

    if (count != 3) {
      this.fanCount = count;
      this.totalCount = this.fanCount + this.creatorCount;
      // this.submitButtonEnabled = false;
      for (var i = 0; i < this.toggleDataFan.length; i++) {
        this.toggleDataFan[i].isDisabled = false;
        if(this.fanCount && this.creatorCount >= 1) {
          this.submitButtonEnabled = true;
        }
       else{ this.submitButtonEnabled = false;}
     

      }
    }
  }
  //////createrof//////////
  onToggleChange1() {
    var count1 = 0;
    for (let i = 0; i < this.toggleDataCreator.length; i++) {
      if (this.toggleDataCreator[i].ischecked) {
        count1++;

      }
    }

    if (count1 == 3) {
      this.creatorCount = 3;
      this.totalCount = this.fanCount + this.creatorCount;
      for (let i = 0; i < this.toggleDataCreator.length; i++) {
        if (this.toggleDataCreator[i].ischecked == false) {
          this.toggleDataCreator[i].isDisabled = true;
        }
      }
    }
  

    if (count1 != 3) {
      this.creatorCount = count1;
      this.totalCount = this.fanCount + this.creatorCount;
      for (let i = 0; i < this.toggleDataCreator.length; i++) {
        this.toggleDataCreator[i].isDisabled = false;

        if(this.fanCount && this.creatorCount >= 1) {
          this.submitButtonEnabled = true;
        }
       else{ this.submitButtonEnabled = false;}
     
      }
    }
  }
  submit() {
    let finalPayload = [];
    let payload = [];

    for (let i = 0; i < this.toggleDataFan.length; i++) {
      console.log(this.toggleDataFan[i].ischecked);
      if (this.toggleDataFan[i].ischecked) {
        payload.push(this.toggleDataFan[i].name);
      }
    }
    console.log(payload);

    for (let i = 0; i < this.toggleDataCreator.length; i++) {
      console.log(this.toggleDataCreator[i].ischecked);
      if (this.toggleDataCreator[i].ischecked) {
        finalPayload.push(this.toggleDataCreator[i].name);
      }
    }
    console.log(finalPayload);

    let finalObject ={
      creatorOf: finalPayload,
      fanOf: payload,
    };
    console.log(finalObject);

    // Post Call
    const data = this.onboardingService.postSetup2(this.userId,finalObject).subscribe();
    console.log(data);
    this.Router.navigate([`/userProfiles/${this.userId}/setup/3`]);
    return data;
  }
}
